<template>
  <div class="comp-ly-show-filters">
    <template v-if="shouldShowTooltip">
      <jw-tooltip :content="showInner">
        <span :title="showInner">{{ truncatedShowInner }}</span>
      </jw-tooltip>
    </template>
    <template v-else>
      {{ showInner }}
    </template>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, onBeforeUnmount, computed } from 'vue';
const props = defineProps({
  showInner: {
    type: String
  },
  showType: {
    type: String // 来源类型
  }
});

const showConfigMap = {
  mapping: {
    largeShow: 6,
    middleShow: 4,
    smallShow: 2,
    miniShow: 2
  },
  condition: {
    largeShow: 12,
    middleShow: 6,
    smallShow: 16,
    miniShow: 10
  },
  filters: {
    largeShow: 18,
    middleShow: 14,
    smallShow: 8,
    miniShow: 10
  },
  firstFilter: {
    largeShow: 6,
    middleShow: 4,
    smallShow: 2,
    miniShow: 2
  }
};

// 当前屏幕宽度
const windowWidth = ref(window.innerWidth);

// 更新窗口宽度的函数
const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

// 计算是否需要显示 tooltip
const shouldShowTooltip = computed(() => props.showInner?.length > maxLength.value);

// 计算截断后的显示文本
const truncatedShowInner = computed(() => showName(props.showInner, maxLength.value));

// 根据屏幕尺寸设置最大显示长度
const maxLength = computed(() => {
  const width = windowWidth.value;
  if (width < 1200) {
    return showConfigMap[props.showType].miniShow;
  } else if (width > 1200 && width < 1510) {
    return showConfigMap[props.showType].smallShow; // 小于 1440px
  } else if (width >= 1510 && width <= 1700) {
    return showConfigMap[props.showType].middleShow; // 1440px 到 1700px 之间
  } else {
    return showConfigMap[props.showType].largeShow; // 大于 1700px
  }
});

// 在组件挂载时执行，初始化并监听resize事件
onMounted(() => {
  window.addEventListener('resize', updateWindowWidth);
});

// 在组件销毁时移除事件监听
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateWindowWidth);
});

const showName = (itemName, sliceSize) => {
  if (itemName?.length > sliceSize) {
    return itemName.slice(0, sliceSize) + '...';
  } else {
    return itemName;
  }
};

const data = reactive({});
const name = ref();
console.log(data, name, props);
</script>
<style scoped lang="less">
@import './ly-show-filters.less';
</style>
